export default __webpack_public_path__ + "static/media/Shaulun.426ed6fd.jpg";